import React from "react";
import CycloneList from "../../../components/user/standAloneProcess/nimbusResume";
import Layout from "../../../components/layouts/verticalLayout";

const NimbusListPage = (props) => {
  return <Layout body={<CycloneList />} />;
};

NimbusListPage.propTypes = {};

export default NimbusListPage;
